/**
 * Applies classes named in `data-onload-classes` once the document is ready.
 *
 * Used to defer expensive background images until after first paint.
 */
export function initSmartLoad(): void {
  const targets = document.querySelectorAll<HTMLElement>('[data-onload-classes]');

  targets.forEach((el) => {
    const classes = el.dataset.onloadClasses;

    if (classes) {
      el.classList.add(...classes.split(/\s+/).filter(Boolean));
    }
  });
}
